/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';

export const CUSTOM_DATA_TYPE_NOTE = "note";
export const CUSTOM_DATA_TYPE_TASK = "task";
export const CUSTOM_DATA_TYPE_OTHER = "other";

export const CustomDataType = {
        [CUSTOM_DATA_TYPE_NOTE]: {
            name: "Note"
        },
        [CUSTOM_DATA_TYPE_TASK]: {
            name: "Task"
        },
        [CUSTOM_DATA_TYPE_OTHER]: {
            name: "Other"
        },
};

export default declareEntity({
    entity: "customDatas",
    graphQL: "CustomData",
    dynamoPrefix: 'org',
    storageType: 'central',
    name: "Custom Data",
    parentRelation: "customDatas",
    fields: (types) => { return {
        id: {
            name: "Custom Data ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        organisation_channel_flow: {
            name: "Organisation+Channel or Flow ID",
            type: "string",
        },
        channel: {
            name: "Application",
            to: () => types['channels'],
            type: "relation",
        },
        channelAddon: {
            name: "Application Addon",
            to: () => types['channelAddons'],
            type: "relation",
            relativeTo: ["channel"],
        },
        flow: {
            name: "Flow",
            to: () => types['flows'],
            type: "relation",
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            required: true,
            filterable: true,
        },
        title: {
            name: "Title",
            type: "string",
            defaultValue: "",
        },
        type: {
            name: "Type",
            type: "enum",
            values: CustomDataType,
            userEditable: false,
        },
        content: {
            name: "Content",
            type: "object",
        },
        assignedTo: {
            name: "Assigned To",
            type: "relation",
            to: () => types['users'],
        },
        deadline: {
            name: "Deadline",
            type: "datetime",
        },
        expiresIn: {
            name: "Expires In",
            description: "Entry will be automatically deleted after this date (keep null for never deleting)",
            type: "datetime",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
